import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as legalEntitiesState from '../reducers';
import * as legalEntitiesReducer from '../reducers/legal-entities-list.reducer';

export const selectLegalEntitiesList = createSelector(
  legalEntitiesState.getLegalEntitiesListState,
  legalEntitiesReducer.getLegalEntitiesList
);

export const selectLegalEntitiesListLoaded = createSelector(
  legalEntitiesState.getLegalEntitiesListState,
  legalEntitiesReducer.getLegalEntitiesListIsLoaded
);

export const getSavedBusinessId = createSelector(legalEntitiesState.getLegalEntitiesListState, legalEntitiesReducer.getSavedBusinessId);
